import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/CommerceClub/Mockstock/1.jpg';
// import p2 from 'assests/Photos/Clubs/CommerceClub/Mockstock/2.jpg';
// import p3 from 'assests/Photos/Clubs/CommerceClub/Mockstock/3.jpg';
// import p4 from 'assests/Photos/Clubs/CommerceClub/Mockstock/4.jpg';
// import p5 from 'assests/Photos/Clubs/CommerceClub/Mockstock/5.jpg';
// import p6 from 'assests/Photos/Clubs/CommerceClub/Mockstock/6.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2023 from '../CommerceAssociation2023/Archive2023';
import SideBarAssoc2026 from '../CommerceAssociation2023/components/SideBarAssoc2023/SideBarAssoc2026';

const MockStock2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/association/CommerceClub/Mockstock/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/CommerceClub/Mockstock/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/CommerceClub/Mockstock/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/CommerceClub/Mockstock/4.webp`;

  

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },  
 
        
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                              FINSPECTRA – WEB REPORT 2026
                                </Typography>
                              
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                   Date:  29 JUNE 2026   &  Venue: BIG AV ROOM & Time: 10:30Am - 12:00Pm  
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                         "The best way to predict the future is to create it." — Peter Drucker
                                <br /><br />
                            </Typography> */}
                                <Typography variant={'subtitle1'} align={'justify'}>
                         The Commerce Association of National Public School, Yeshwanthpur, organised an educational event,<strong> 'Mock Stock'</strong>, 
                         for students of Classes 10 to 12 on <strong>Monday, June 29.</strong> The event blended strategy, competition and experiential learning to recreate the excitement of stock market trading without involving real money. The programme 
                         commenced with a written test on stock market fundamentals to assess participants' understanding of trading concepts, 
                         investment strategies and financial decision-making. Students who qualified in the preliminary round advanced to the main event.
                               <br/>
The finalists took part in a live auction of shares, where they built their investment portfolios through competitive bidding.
 As the competition progressed, participants faced simulated market crises in each round, requiring them to analyse
  changing conditions and make strategic trading decisions. Two intense trading sessions followed, during which students bought and sold shares in real time, testing their analytical skills, risk assessment, and decision-making abilities.       
  <br/>
  Mock Stock proved to be an engaging and enriching experience, offering students valuable insights into the functioning of financial markets and the risks associated with investing. The event successfully bridged classroom learning 
  with practical application, fostering financial awareness and critical thinking among the participants.
                           <br/>
                           </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "The individual investor should act consistently as an investor and not as a speculator." — Ben Graham
                                <br />
                            </Typography> */}
                            </Box>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 400}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                           <SideBarAssoc2026/>
                        </Box>
                        <Box marginBottom={4}>
                           <Archive2023 />
                        </Box>
                      
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default MockStock2026;